import {
	ChangeDetectorRef,
	Component,
	Inject, // EventEmitter,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
	L10N_CONFIG,
	L10N_LOCALE,
	L10nConfig,
	L10nLocale,
	L10nTranslatePipe,
	L10nTranslationService
} from 'angular-l10n';

import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FormControl, FormsModule } from "@angular/forms";
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import { CsvConfiguration, Ng2CsvModule, Ng2CsvService } from "ng2csv";
import { ReplaySubject, Subject } from "rxjs";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { ErrorHelper } from "../../shared/error.helper";
import { LoggerService } from "../../shared/logger.service";
import { SessionService } from "../../shared/session.service";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { Monatlicheplanmenge } from "./monatlicheplanmenge.model";

const PATH_FILE = 'app/protected/monatlicheplanmenge/monatlicheplanmenge.component.ts';
const OBJ_LNG_NAME = 'monatlicheplanmenge';
const BACKEND_PATH_PREFIX = 'mpm';

@Component({
	selector: 'oase-monatlicheplanmenge',
	templateUrl: './monatlicheplanmenge.component.html',
	styleUrls: ['./monatlicheplanmenge.component.css'],
	standalone: true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, Ng2CsvModule, FlexModule]

})
export class MonatlicheplanmengeComponent extends Tabelle<Monatlicheplanmenge> {

	spList: Monatlicheplanmenge[] = new Array<Monatlicheplanmenge>();
	// neu: Lieferant = null;
	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredMonatlicheplanmengeen: ReplaySubject<Monatlicheplanmenge[]> = new ReplaySubject<Monatlicheplanmenge[]>(1);
	public datum = null;
	darfExport: boolean = false;
	summeEingabe: number = 0;
	exportData: Monatlicheplanmenge[] = Array<Monatlicheplanmenge>();
	alledatengewartet: boolean = true;

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public datepipe: DatePipe,
		public ng2CsvService: Ng2CsvService,
		public _logger: LoggerService) {

		super(route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
			OBJ_LNG_NAME: OBJ_LNG_NAME,
			BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
			ROUTE_NAME: "/mpm",
			PATH_FILE: PATH_FILE,
			extraDataForAdding: {}
		}
		);
		this.displayedColumns = [
			'monatzahl',
			'ablaufdatum1',
			'ablaufdatum2',
			'planmenge',
		];
		this.darfExport = this.authService.hatRecht('recht.planmengenexport');
	}

	getApiParams() {
		return "seite";
	}

	public afterDataIsLoaded() {
		for (const element of this.dataSource.content) {
			if (element.planmenge == null)
				this.alledatengewartet = false;
		}
		this._logger.log(PATH_FILE + ' - afterDataIsLoaded alledatengewarted:', this.alledatengewartet);
	}

	checkPlanmengeSumme(monatlicheplanmenge: Monatlicheplanmenge) {
		this.summeEingabe =
			this.dataSource.content[0].planmenge + this.dataSource.content[1].planmenge + this.dataSource.content[2].planmenge + this.dataSource.content[3].planmenge +
			this.dataSource.content[4].planmenge + this.dataSource.content[5].planmenge + this.dataSource.content[6].planmenge + this.dataSource.content[7].planmenge +
			this.dataSource.content[8].planmenge + this.dataSource.content[9].planmenge + this.dataSource.content[10].planmenge + this.dataSource.content[11].planmenge;

		this.ladedaten = false;
	}

	exportMonatlichePlanmenge() {

		this.http
			.get<Monatlicheplanmenge[]>(this.REST_API + '/listeFuerExport/')
			// Um mehrfachaufrufe zu verhindern
			.subscribe({
				next: (data) => {
					this.ladedaten = false;
					this.exportData = data;
					const csvConfig = new CsvConfiguration();
					csvConfig.delimiter = ';';
					csvConfig.includeHeaderLine = true;

					this.ng2CsvService.download(this.exportData, "Planmengen", undefined, csvConfig);
				},
				error: (err) => {
					this.ladedaten = false;
					ErrorHelper.handleError(err, "Fehler beim holen der exportPlanmengen", this._logger, this.translation);
				},
				complete: () => {
					this.ladedaten = false;

					this._logger.log(PATH_FILE + ' - exportMonatlichePlanmenge FERTIG');
					this._logger.log(PATH_FILE + ' - exportMonatlichePlanmenge data: ', this.exportData)
				}
			});
	}

	speichere(monatlicheplanmenge: Monatlicheplanmenge) {
		this._logger.log(PATH_FILE + ' - speichernAend BEGIN');
		this._logger.log(PATH_FILE + ' - speichernAend - monatlicheplanmenge: ', monatlicheplanmenge);

		let snacknachricht = this.translation.translate('allgemein.daten.hinzugefügt', { typ: this.translation.translate('monatlicheplanmenge.typ') });
		this.speichernAmServer(monatlicheplanmenge, snacknachricht);
	} // speichernAend

	speichernAmServer(monatlicheplanmenge: Monatlicheplanmenge, snacknachricht: string) {
		this._logger.debug(PATH_FILE + ' - speichern BEGIN');
		this._logger.debug(PATH_FILE + ' - speichern - monatlicheplanmenge: ', JSON.stringify(monatlicheplanmenge));
		this._logger.log(PATH_FILE + ' - speichern - http: ' + this.REST_API + 'hinzufuegen/' + monatlicheplanmenge.id);

		let request = null;
		this.ladedaten = true;
		request = this.http.post(this.REST_API + '/hinzufuegen/' + monatlicheplanmenge.id, JSON.stringify(monatlicheplanmenge), {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' })
		});
		request
			.subscribe(
				data => {
					this.ladedaten = false;
					this.openSnackBar(snacknachricht);
					this._logger.log(PATH_FILE + ' - speichern End');
					this.alledatengewartet = true;
					this.dataSource._reloadData.next(true); // Der Datenquelle mitteilen das sich Daten geändert habe und die Aktuelle Seite neu zu laden ist.
				},
				err => {
					this.ladedaten = false;
					ErrorHelper.handleError(err, "Fehler beim speichern der Monatlicheplanmenge", this._logger, this.translation);
				});
	} // speichern


}
